import {
	Button,
	BellIcon,
	Modal,
	ModalBody,
	ModalFooter,
	Stack,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import EmptyState from "./empty-state";
import { usePushNotifications } from "../hooks/use-push-notifications";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../hooks/use-app-context";

export const PushNotificationModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
	const { activatePush, isLoading, isActivated } = usePushNotifications();
	const { t } = useTranslation();
	const { safeArea } = useAppContext();

	const activate = () => {
		activatePush();
	};

	useEffect(() => {
		if (isActivated && isOpen) {
			onClose();
		}
	}, [isActivated, isOpen, onClose]);

	return (
		<Modal onClose={onClose} isOpen={isOpen} size="full">
			<ModalBody p={ThemeSpaceVariable.Large} mt={ThemeSpaceVariable.X2Large}>
				<EmptyState
					icon={BellIcon}
					text={t("post_login_onboarding_passwordless_empty_description")}
					title={t("post_login_onboarding_passwordless_empty_title")}
				/>
			</ModalBody>
			<ModalFooter pb={safeArea.bottomAsPx()}>
				<Stack
					w={"100%"}
					gap={ThemeSpaceVariable.Medium}
					p={ThemeSpaceVariable.Medium}
					pb={ThemeSpaceVariable.Large}
				>
					<Button variant={"primary"} onClick={activate} isLoading={isLoading} size={"lg"}>
						{t("post_login_onboarding_passwordless_activate")}
					</Button>
					<Button variant={"tertiary"} onClick={() => onClose()} size={"lg"}>
						{t("choice_not_now")}
					</Button>
				</Stack>
			</ModalFooter>
		</Modal>
	);
};
